import React from 'react'
import Index from './Index'

const StatsIndex = () => {
    return (
        <Index />
    )
}

export default StatsIndex